import * as Yup from 'yup';
import { INumberControlField } from '../types';

export default function textFieldValidation(field: INumberControlField) {
  let schema = Yup.number();
  if (field.is_mandatory) {
    schema = schema.required('This field is required').test({
      test: (value) => {
        if (value === null || value === undefined) {
          return false;
        }
        if (typeof value === 'string' && !value) {
          return false;
        }
        return true;
      },
      message: 'This is required'
    });
  }
  return {
    [field.name]: schema
  };
}
